// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';

import { DomainListResponse } from '@par/app/core/model/custom-domains.response';

export const getDomainListRequested = createAction('[SELECT DOMAIN] Get Domain List Requested');
export const getDomainListSucceeded = createAction('[SELECT DOMAIN] Get Domain List Succeeded', props<{
  response: DomainListResponse
}>());
export const getDomainListFailed = createAction('[SELECT DOMAIN] Get Domain List Failed');
